import { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

const lazyTeamManagement = () =>
  import('./management/TeamManagementRoute').then((m) => ({
    Component: m.TeamManagementRoute,
  }));

export const teamRoutes: RouteObject[] = [
  {
    path: 'accounts',
    lazy: lazyTeamManagement,
  },
  {
    index: true,
    lazy: () =>
      import('./assignment-management/AssignmentManagementRoute').then((m) => ({
        Component: m.AssignmentManagementRoute,
      })),
  },
  {
    path: 'driver-profile',
    lazy: () =>
      import('./driver-profile/DriverProfileRoute').then((m) => ({
        Component: m.DriverProfileRoute,
      })),
  },
  {
    path: 'attendant-profile',
    lazy: () =>
      import('./attendant/AttendantRoute').then((m) => ({
        Component: m.AttendantRoute,
      })),
  },
  {
    path: 'member-credentials',
    lazy: () =>
      import('./member-credentials/MemeberCredentialsRoute').then((m) => ({
        Component: m.MemberCredentialsRoute,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/team" linkText="Go back to team" />
    ),
  },
];

export const rideOrderingPortalTeamRoutes: RouteObject[] = [
  {
    index: true,
    lazy: lazyTeamManagement,
  },
];
